import React, { useEffect, useState, useContext } from 'react'
import VideoPlayer from '../VideoPlayer';
import { AboutContainer, Card, TextWrapper, TopLine, SectionText, RowOneContainer, RowTwoContainer, BtnWrap, BtnLink } from './AboutElements';
import { AccountContext } from '../Accounts'
import { useNavigate } from 'react-router-dom'

const About = () => {

    const { getSession } = useContext(AccountContext);
    const [status, setStatus] = useState();

    const history = useNavigate();

    useEffect(() => {
        getSession()
            .then(session => {
                // console.log(session.idToken.payload);
                setStatus(true);
            })
            .catch(err => {
                console.log(err);
                history('/signin')
            })
    });

    return (
        status ? (
            <AboutContainer>
                <RowOneContainer>
                    <TopLine>Cash Crew</TopLine>
                    <VideoPlayer file={'CC_intro.mp4'} />
                </RowOneContainer>
                <RowOneContainer>
                    <TopLine>Crew Builder</TopLine>
                    <VideoPlayer file={'CC_Base1.mp4'} />
                </RowOneContainer>
                <RowOneContainer>
                    <TopLine>Crew Builder #1</TopLine>
                    <VideoPlayer file={'CC_Base2.mp4'} />
                </RowOneContainer>
                <RowOneContainer>
                    <TopLine>Crew Builder #2</TopLine>
                    <VideoPlayer file={'CC_Base3.mp4'} />
                </RowOneContainer>
            </AboutContainer >
        ) :
            <></>
    );
};

export default About;

